export default function setTextAccDescriptionAction(description) {
    return {
        type: 'SET_DESCRIPTION',
        payload: description
    }
}